
$(document).on("click",".dropdown-item", function(event){                  
    var width = $(window).width();
	if (width <= 1250){
		$(".navbar-toggler").addClass('collapsed')
		$(".navbar-collapse").removeClass('show')
		$(".navbar-toggler").attr('aria-expanded', false)
    $("body").removeClass('lockscroll')

    }
});

$(document).on("click",".navbar-toggler", function(event){                  
    $("body").toggleClass('lockscroll')
});

//Header Fixed
$(window).scroll(function(){
  var sticky = $('header.mainHeader-section'),
      scroll = $(window).scrollTop();

  if (scroll >= 100) sticky.addClass('sticky');
  else sticky.removeClass('sticky');
});
//End Header










//////////////////
// WEBPACK FOOTER
// ./static/website/js/custom.js
// module id = Ov23
// module chunks = 7